import React from "react";
import { Sparkles } from "lucide-react";

/**
 * The Kinly Orb — persistent floating bubble. Tap to open chat with Kinly.
 * Pulsates when `hasDrafts` is true.
 */
export function KinlyOrb({ onClick, hasDrafts = false }) {
  return (
    <button
      data-testid="kinly-orb"
      onClick={onClick}
      aria-label="Open Kinly"
      className={[
        "absolute right-4 bottom-[calc(60px+env(safe-area-inset-bottom)+18px)]",
        "w-14 h-14 rounded-full z-50 tap",
        "bg-primary text-primary-foreground",
        "flex items-center justify-center",
        "shadow-[0_10px_24px_-6px_hsl(12_69%_40%/0.45)]",
        hasDrafts ? "orb-pulse" : "",
      ].join(" ")}
    >
      <Sparkles className="w-6 h-6" strokeWidth={1.8} />
      {hasDrafts && (
        <span
          data-testid="kinly-orb-draft-badge"
          className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-kinly-mustard text-foreground text-[11px] font-semibold flex items-center justify-center border-2 border-background"
        >
          •
        </span>
      )}
    </button>
  );
}
